<template>
  <gg-modal :is-active="isActive" @close="close">
    <template v-slot:toolbar>
      Delete Alias?
    </template>
    <template v-slot:body>
      Are you sure you want to delete the alias “{{ alias && alias.dest }}”?
      Mail sent to it will no longer reach {{ mailbox.email }}.
    </template>
    <template v-slot:actions>
      <v-spacer></v-spacer>
      <gg-btn secondary @click="close">Cancel</gg-btn>
      <gg-btn primary :loading="deleting" @click="remove">Delete</gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import { mapActions } from 'vuex'

/**
 * Shared by the Overview Aliases card and the Aliases tab, which both delete
 * the same rows. Kept in one place so the two cannot drift apart on either the
 * wording or the `dest` / `forward` mapping, which is the field pair that is
 * easy to get the wrong way round (see emailHub's aliasCountsByTarget).
 *
 * GGModal is eager, so this exists before it is ever opened and `alias` is null
 * until a row is picked.
 */
export default {
  name: 'DeleteAliasModal',
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    alias: {
      type: Object,
      default: null,
    },
    mailbox: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      deleting: false,
    }
  },
  methods: {
    ...mapActions('emailHub', ['deleteAlias']),
    ...mapActions(['reportError', 'reportSuccess']),
    close () {
      this.$emit('close')
    },
    async remove () {
      if (!this.alias) return

      this.deleting = true
      try {
        await this.deleteAlias({
          serviceId: this.mailbox.serviceId,
          dest: this.alias.dest,
          forward: this.alias.forward,
        })
        this.reportSuccess('Alias successfully deleted.')
        this.$emit('deleted')
        this.close()
      } catch (e) {
        this.reportError(e)
      } finally {
        this.deleting = false
      }
    },
  },
}
</script>
